/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Metabolic Control Diabetes List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './MetabolicControlDiabetesListView';

export const mapStateToPropsMetabolicControlDiabetesList = mapStateToProps;
export const mapDispatchToPropsMetabolicControlDiabetesList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsMetabolicControlDiabetesList,
  mapDispatchToPropsMetabolicControlDiabetesList
)(View);
